import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = new Map();

const loadBlob = (path) => {
  if (!cache.has(path)) {
    const p = api.get(`/images/${path}`, { responseType: "blob" }).then((r) => URL.createObjectURL(r.data));
    p.catch(() => cache.delete(path));
    cache.set(path, p);
  }
  return cache.get(path);
};

export const AuthImage = ({ path, alt, className }) => {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let live = true;
    loadBlob(path).then((u) => live && setSrc(u)).catch(() => live && setFailed(true));
    return () => { live = false; };
  }, [path]);
  if (failed) return null;
  if (!src) return <div data-img-loading="true" className={`${className} bg-zinc-200 animate-pulse`} />;
  return <img src={src} alt={alt} className={className} />;
};
